import { z } from 'zod';
import { isoTimestampSchema } from './common';

/**
 * Offline command envelope (spec §7.3, §9.2). There is deliberately no tenant field:
 * tenant, branch membership and permissions are resolved from the session/device.
 */
export const syncCommandSchema = z.object({
  command_id: z.uuid(),
  branch_id: z.uuid(),
  device_id: z.uuid(),
  device_sequence: z.number().int().nonnegative(),
  created_at: isoTimestampSchema,
  expected_version: z.number().int().nonnegative().optional(),
  operation: z.string().regex(/^[a-z_]+\.[a-z_]+$/),
  payload: z.record(z.string(), z.unknown()),
});
export type SyncCommand = z.infer<typeof syncCommandSchema>;

export const syncCommandResultSchema = z.discriminatedUnion('status', [
  z.object({
    command_id: z.uuid(),
    status: z.literal('accepted'),
    entity_versions: z.record(z.string(), z.number().int()),
  }),
  z.object({
    command_id: z.uuid(),
    status: z.literal('rejected'),
    error_code: z.string(),
    message: z.string(),
  }),
  z.object({
    command_id: z.uuid(),
    status: z.literal('conflict'),
    current_version: z.number().int(),
  }),
]);
export type SyncCommandResult = z.infer<typeof syncCommandResultSchema>;
